import React from 'react';

const Spinner = ({ 
  size = 'medium', 
  text = 'Curating...', // Luxury default text
  fullScreen = true     // Default to full screen overlay
}) => {

  // Minimalist Size Config (Thinner borders for larger sizes)
  const sizeConfig = {
    small: 'w-5 h-5 border-[1px]',
    medium: 'w-10 h-10 border-[1px]',
    large: 'w-16 h-16 border-[1.5px]'
  };

  return (
    <div 
      className={`
        ${fullScreen ? 'fixed inset-0 z-[9999]' : 'relative py-12 w-full'}
        flex flex-col items-center justify-center
        bg-white/90 backdrop-blur-sm transition-all duration-500
      `}
    >
      {/* THE SPINNER
         Concept: A faint gray circle with a single sharp black arc 
      */}
      <div className={`
        ${sizeConfig[size] || sizeConfig.medium}
        rounded-full
        border-gray-200       /* Subtle track */
        border-t-black        /* Sharp active indicator */
        animate-spin          /* Smooth infinite rotation */
      `}/>

      {/* THE TEXT
         Concept: Editorial caption style 
      */}
      {text && (
        <div className="mt-6 animate-pulse">
           <span className="text-[10px] uppercase tracking-[0.3em] text-black font-medium">
             {text}
           </span>
        </div>
      )}

    </div>
  );
}

export default Spinner;